import { useCallback } from 'react';
import useAppSelector, { useAppDispatch } from '../../app/redux/useAppSelector';
import { UIActions } from '../../ui/uiSlice';
import safeParseUrl from '../../utils/url/safeParseUrl';

const useButtonAction = () => {
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector((state) => state.session.user);
  return useCallback(
    async (destination: string) => {
      const url = safeParseUrl(destination);
      if (!url) {
        dispatch(
          UIActions.pushToast(
            {
              level: 'error',
              message:
                'There was an error triggering the action: The URL of the action is invalid.',
            },
            3000,
          ),
        );
        return;
      }

      url.searchParams.set('userId', currentUser.id);

      try {
        const result = await fetch(url.toString(), {
          method: 'POST',
          referrer: window.location.host,
          headers: {
            'User-Agent': window.navigator.userAgent,
          },
        });

        if (result.ok) {
          dispatch(
            UIActions.pushToast(
              {
                level: 'success',
                message: 'Action successfully triggered',
              },
              3000,
            ),
          );
        } else {
          dispatch(
            UIActions.pushToast(
              {
                level: 'error',
                message: `Action triggered a ${result.status} response`,
              },
              3000,
            ),
          );
        }
      } catch (e) {
        dispatch(
          UIActions.pushToast(
            {
              level: 'error',
              message: 'There was an error triggering the action',
            },
            3000,
          ),
        );
      }
    },
    [dispatch, currentUser.id],
  );
};

export default useButtonAction;
